// extracted by LIB_CSS_EXTRACT_LOADER
import "./label_module.css"
export default {"label":"label-sOXmNO"};